import { ChevronDown, ChevronUp } from "lucide-react";
import PrimaryButton from "../PrimaryButton";
import { useEffect, useState } from "react";
import cx from "classnames";
import classes from "./jobBoost.module.css";
import BOOST_EVENTS from "utils/BoostEvents";
import LogService from "services/LogService";
import { getBoostDetails } from "services/boostUtils";
import { isMobileDevice } from "services/utils";
import useModalStore from "zustandStores/useModalStore";
import useCreditProfileStore from "zustandStores/userCreditProfileStore";
import useSingleJobSkus from "zustandStores/singleJobSkus";

function JobBoost({ renderFunction, boostDetails = {}, callBack, data = {} }) {
  const isMobile = isMobileDevice();
  const { source, jobId } = data;
  const [showBody, setBody] = useState(true);
  const { status, expiryDate } = boostDetails;
  const { setModalData } = useModalStore(state => ({
    modalData: state.modalData,
    setModalData: state.setModalData
  }));
  const {
    initialState,
    inProgress,
    completed,
    notEligible,
    jobExpiringInEligible,
    expiryDateRender,
    boostYetToStart,
    startsIn,
    boostAgain,
    availableBoost
  } = getBoostDetails(boostDetails);

  const { credtProfileData } = useCreditProfileStore(state => ({
    credtProfileData: state.data
  }));
  const { freeBoostConsumed = false, totalAvailableCredits } =
    credtProfileData || {};

  useEffect(() => {
    if (!initialState && isMobile) {
      setBody(false);
    }
  }, [initialState, isMobile]);

  const { fetchSingleJobCreditMetadata } = useSingleJobSkus(state => ({
    fetchSingleJobCreditMetadata: state.fetchData
  }));

  function onBoost() {
    LogService.log(BOOST_EVENTS.BOOST_CLICKED, {
      source,
      jobId,
      freeBoostConsumed,
      totalAvailableCredits,
      availableBoost
    });
    // On click of Boost, call credit metadata
    fetchSingleJobCreditMetadata({ jobId });
    setModalData({
      state: "open",
      type: "jobBoost",
      boostDetails: { ...boostDetails, ...data },
      callBack: callBack
    });
  }
  // if (!status || notEligible) return null;
  if (renderFunction) return <>{renderFunction({ onBoost })}</>;
  let icon = "/hire/mboost.svg";
  let bgColor = "bg-violet-50";
  let shock = "/hire/purpleshock.svg";
  let heading = "Start Job Boost";
  let bodyTitle = "Boost your job for 24 hours";
  let bodySubTitle = "& reach even more candidates";

  // if (boostAgain) {
  //   icon = "/hire/mboost.svg";
  //   bgColor = "bg-violet-50";
  //   shock = "/hire/purpleshock.svg";
  //   heading = "Start Job boost";
  //   bodyTitle = "Last boost was a success";
  //   bodySubTitle = "Boost again for more reach";
  // }

  // if (inProgress) {
  //   bgColor = "bg-green-50";
  //   shock = "/hire/greenshock.svg";
  //   icon = "/hire/boosting.svg";
  //   heading = "Your Job is Boosted!";
  //   bodyTitle = "It is visible to more candidates than usual";
  //   bodySubTitle = `Job boost ends at ${expiryDateRender}`;
  // }

  // if (completed) {
  //   icon = "/hire/mboost.svg";
  //   bgColor = "bg-violet-50";
  //   shock = "/hire/purpleshock.svg";
  //   heading = "Your Job boost is complete!";
  //   bodyTitle = "Congratulations on a successful boost";
  //   bodySubTitle = "Job was visible to more candidates than usual";
  // }
  // if (boostYetToStart) {
  //   icon = "/hire/mboost.svg";
  //   bgColor = "bg-violet-50";
  //   shock = "/hire/purpleshock.svg";
  //   heading = "Job boost";
  //   bodyTitle = "Need more candidates?";
  //   bodySubTitle = "Job boost will be available in";
  // }
  return (
    <div className="flex flex-col border rounded-md ">
      <div className={cx("flex-row flex justify-between   p-4", bgColor)}>
        <div className="flex-row flex items-center space-x-2 ">
          <span className="flex ">
            <img src={icon} alt="" />
          </span>
          <span className="text-base font-semibold text-slate-800">
            {heading}
          </span>
        </div>
        {
          <span className="flex relative" onClick={() => setBody(!showBody)}>
            <img className={cx(classes.shock)} src={`${shock}`} alt="" />
            {showBody ? (
              <ChevronUp className="cursor-pointer sm:invisible " size="16" />
            ) : (
              <ChevronDown className="cursor-pointer sm:invisible" size="16" />
            )}
          </span>
        }
      </div>
      {showBody ? (
        <div className="flex flex-row sm:flex-col md:flex-col xl:flex-row py-3 px-4 md:items-start sm:items-start xl:items-center justify-between">
          <div>
            <div className="text-slate-800 text-sm font-semibold">
              {bodyTitle}
            </div>
            <div className="text-sm font-normal text-gray-400 ">
              {bodySubTitle}
            </div>
          </div>
          {initialState || jobExpiringInEligible ? (
            <div>
              <PrimaryButton
                onClick={onBoost}
                secondary
                buttonText="Boost Job"
              />
            </div>
          ) : null}
          {boostYetToStart &&
          startsIn !== "ERROR" &&
          startsIn !== "TIME_EXCEED" ? (
            <div
              className={cx(
                "bg-violet-50 px-2 py-1 items-center flex",
                classes.timer
              )}
            >
              <span className="text-base font-semibold text-slate-800">
                {startsIn.hours}
              </span>
              <span className="text-base  text-gray-400"> hr</span>{" "}
              <span className="text-base  text-gray-400">:</span>{" "}
              <span className="text-base font-semibold text-slate-800">
                {startsIn.minutes}
              </span>
              <span className="text-base  text-gray-400"> mins</span>
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}

export default JobBoost;
